import moment from 'moment';
import React from "react";

/**
 *
 * @param org
 * @param date
 * @param type
 * @returns {string}
 */
export function getDateFormat(org, date, type) {
    const defaultFormat = {
        'day': 'D MMM',
        'dayLong': 'D MMM H:mm',
        'month': 'MMM YYYY',
        'monthLong': 'MMM YYYY H:mm',
        'short': 'DD MMM YYYY',
        'long': 'DD MMM YYYY H:mm'
    };
    const format = !!org && org.dateFormat? org.dateFormat : defaultFormat;
    const keyFormat = (type && type === 'short')? 'short' : 'long';
    return date? moment(date).format(format[keyFormat]) : '--';
}

export function getDOB(currentOrg, dateOfBirth, gender, className) {
    const dobMoment = moment(dateOfBirth);
    const getGender = () => {
        if (gender && gender.length) {
            const lower = gender.toLowerCase();
            return gender.charAt(0).toUpperCase()+lower.slice(1);
        }
        return '';
    }
    return (
        <>
            <p className={className}>
                {dobMoment? moment().diff(dobMoment, 'years') : '--'}yo {getGender()}
            </p>
            <p className={className}>
                ({getDateFormat(currentOrg, dateOfBirth, 'short')})
            </p>
        </>
    );
}
